module.exports = "<div class=\"thumb\">\n    <div class=\"cover\"></div>\n    <div class=\"info\"><span class=\"page\"></span> / <%=nbPages%></div>\n</div>";
